<form [formGroup]='propertyTypeDetailsTo'
      (ngSubmit)='onSubmit()'
      id='{{formGroupName}}'>

	<div class='step-title' i18n>Which <span class='color-blue'>floor</span> are you going to live on?</div>

	<div class='form-control form-control-m-full'>
		<mat-form-field class='centered-field'>
			<mat-label i18n='@@labelFloor'>Select your floor</mat-label>
			<mat-select [tabIndex]='formService.verifyTabIndex( formGroupName )' formControlName='floor' (selectionChange)="onFloorChange($event)">
				<mat-option *ngFor='let floorLevel of floorLevels' [value]='floorLevel.value'>
					{{floorLevel.label}}
				</mat-option>
			</mat-select>
		</mat-form-field>
	</div>

	<ng-container *ngIf='elevatorEnabled'>

		<div class='step-title step-title-margin-top' i18n>Will there be <span class='color-blue'>a lift</span> available?</div>

		<div class='form-control elevator-control'>
			<mat-radio-group (change)='onElevatorChange()' formControlName='elevator'
			                 aria-label='Select an option'
			                 class='custom-radio-group centered-field'>
				<mat-radio-button
					value='1'
					[tabIndex]='formService.verifyTabIndex( formGroupName )'>
					<div class='option' i18n='@@optionYes'>Yes</div>
				</mat-radio-button>
				<mat-radio-button
					value='2'
					[tabIndex]='formService.verifyTabIndex( formGroupName )'>
					<div class='option' i18n='@@optionNo'>No</div>
				</mat-radio-button>
			</mat-radio-group>
		</div>

	</ng-container>

	<div class='step-footer step-footer-center'>
		<div class='step-footer-buttons'>
			<button class='back' type='button' (click)='formService.backMainForm()'><mat-icon svgIcon='icons:chevron-left'></mat-icon><ng-container i18n='@@buttonBack'>Back</ng-container></button>
			<button class='submit' type='submit'><ng-container i18n='@@buttonContinue'>Continue</ng-container><mat-icon svgIcon='icons:chevron-right'></mat-icon></button>
		</div>
	</div>

</form>

